/** Planning Phase 3 P3-6b (plan D-294): the OSC external-id panel, search, intake and bundle (planning.osc.*). */
export default {
  osc: {
    ids: {
      otherScheme: 'Another scheme…',
      customScheme: 'Scheme id',
      issuerFromSettings: 'Defaults to the council code {{pbt}} from Settings → Planning.',
      issuerMissing: 'No council code in Settings → Planning: type who issued the id.',
      patternWarning: 'This does not look like a usual {{scheme}}. Check it against OSC; you can still link it.',
      linkedWithWarning: 'Linked, but it does not look like a usual id of its kind. Check it against OSC.',
      multi: 'can name several submissions',
      unlink: 'Unlink',
      unlinkLabel: 'Unlink {{value}}',
      unlinkTitle: 'Unlink this reference',
      unlinkBody:
        'The reference {{value}} is removed from this submission. Its history keeps the link and your reason.',
      reason: 'Reason',
      reasonHint: 'Kept in the case history; the applicant does not see it.',
      reasonRequired: 'Give a reason.',
      confirm: 'Unlink it',
      cancel: 'Keep it',
    },
    search: {
      label: 'External reference',
      placeholder: 'An OSC number, exactly as recorded',
      submit: 'Find',
      clear: 'Clear the reference',
      active: 'Submissions linked to {{value}}',
      landmark: 'Find by external reference',
    },
    intake: {
      title: 'Documents from OSC',
      intro: 'Take in the PDFs of the application from OSC 3.0 Plus, one or several at a time.',
      choose: 'Choose PDFs',
      type: 'Document type for {{name}}',
      upload: 'Take them in',
      progress: 'Taking in {{done}} of {{total}}…',
      done: 'Taken in.',
      failed: 'Not taken in. Check the file and try again.',
      remove: 'Remove {{name}}',
      retry: 'Try again',
      retryLabel: 'Try again: {{name}}',
    },
    bundle: {
      title: 'OSC bundle',
      intro:
        'What to key into OSC 3.0 Plus: the entry sheet, the checklist and the PDFs. Nothing is sent to OSC from here.',
      prepare: 'Prepare the bundle',
      refresh: 'Prepare it again',
      download: 'Download the bundle (zip)',
      progress: 'Fetching {{done}} of {{total}} PDFs…',
      failed: 'The bundle could not be built. Try again.',
      header: 'Submission',
      caseRef: 'Reference',
      stage: 'Current step',
      checklist: 'Mirrored to OSC',
      checklistHint: 'Tick an item once it is keyed into OSC. Only officers of this council see the ticks.',
      markLabel: 'Mirrored: {{item}}',
      entrySheet: 'Entry sheet',
      documents: 'PDFs for OSC',
      noDocuments: 'No PDF to copy to OSC.',
      excluded: 'Left out of the bundle',
      marking: 'Saving…',
      withdrawn: 'Referral withdrawn',
      withdrawnWithAgency: 'Referral to {{agency}} withdrawn',
      referralKinds: { internal: 'Council department', external: 'Outside agency' },
      referralStatuses: { open: 'Open', answered: 'Answered', withdrawn: 'Withdrawn' },
      yes: 'Yes',
      no: 'No',
      kinds: {
        transition: 'Step',
        referral_requested: 'Referral sent',
        referral_answered: 'Referral answered',
        document: 'Document',
      },
      // A referral item names its agency: one circulation sends one referral per agency at the same moment.
      kindsWithAgency: {
        referral_requested: 'Referral sent to {{agency}}',
        referral_answered: 'Referral answered by {{agency}}',
      },
      reasons: { too_large: 'over 10 MB: OSC refuses it', not_pdf: 'not a PDF', inbound: 'came from OSC' },
      outcomes: { requirements: 'Requirements', no_requirements: 'No requirements', deemed: 'No reply (deemed)' },
      fields: {
        agency: 'Agency',
        kind: 'Internal or outside',
        requestedOn: 'Requested on',
        dueOn: 'Due on',
        outcome: 'Answer',
        answeredOn: 'Answered on',
        late: 'Late',
        conditions: 'Number of requirements',
        pCodes: 'Compliance stages',
        docType: 'Document type',
        file: 'File in the bundle',
        size: 'Size (bytes)',
        revision: 'Revision',
        status: 'Request status',
      },
      csv: {
        item: 'Item',
        screen: 'OSC screen',
        field: 'Field',
        value: 'Value',
        date: 'Date',
        mirrored: 'Mirrored to OSC',
      },
    },
  },
} as const
